module.exports = __webpack_public_path__ + "img/dbs.a3c312e5.png";